import { Input } from 'antd';
import './InputPasswordComponent.scss';

const InputPasswordComponent = ({
  id,
  placeholder,
  required,
  value,
  onChange,
  field,
  size,
}) => {
  return (
    <Input.Password
      id={id}
      size={size}
      name={id}
      placeholder={placeholder}
      value={value}
      autoComplete="off"
      required={required}
      onChange={e => {
        if (onChange) onChange(e.target.value);
      }}
      {...field}
    />
  );
};

export default InputPasswordComponent;
